import { createAction } from '@reduxjs/toolkit'
import { Locale } from 'modules/locale/models'

export const setLanguage = createAction('locale/setLanguage', (locale: Locale) => {
  localStorage.setItem('locale', locale)
  return { payload: locale }
})
